(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("iroTransparencyPlugin", [], factory);
	else if(typeof exports === 'object')
		exports["iroTransparencyPlugin"] = factory();
	else
		root["iroTransparencyPlugin"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 